// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMyStoneMall_container__XQdiU {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.SideMyStoneMall_main__UAlds {
    width: 100%;
    height: 100%;
}

.SideMyStoneMall_title_item__uukof {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    padding-left: 10px;
    margin-bottom: 5px;
    cursor: pointer;
    border-radius: 6px;
    -webkit-user-select: none;
            user-select: none;
}

.SideMyStoneMall_title_item__uukof:hover {
    background-color: rgba(255, 255, 255, 0.15);
}

.SideMyStoneMall_collapsibleContent__HVybw {
    overflow: hidden;
    transition: max-height 0.2s ease-in-out;
}

.SideMyStoneMall_item_collapsed__ArwtD {
    max-height: 0;
}

.SideMyStoneMall_item_expanded__cXG2N {
    max-height: 300px;
}

.SideMyStoneMall_expert_butn_box__c6kom {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 40px);
    height: 100%;
    cursor: pointer;
}

.SideMyStoneMall_img__3kBNA {
    width: 24px;
    height: 24px;
    margin-right: 6px;
}

.SideMyStoneMall_text__jK84r {
    width: calc(100% - 30px - 12px);
    color: #e7e7e7;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.SideMyStoneMall_shrink_box__8lYYa {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
}

.SideMyStoneMall_shrink_img__T2NjJ {
    width: 11px;
    height: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideMyStoneMall/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf","sourcesContent":[".container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.main {\n    width: 100%;\n    height: 100%;\n}\n\n.title_item {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 40px;\n    padding-left: 10px;\n    margin-bottom: 5px;\n    cursor: pointer;\n    border-radius: 6px;\n    user-select: none;\n}\n\n.title_item:hover {\n    background-color: rgba(255, 255, 255, 0.15);\n}\n\n.collapsibleContent {\n    overflow: hidden;\n    transition: max-height 0.2s ease-in-out;\n}\n\n.item_collapsed {\n    max-height: 0;\n}\n\n.item_expanded {\n    max-height: 300px;\n}\n\n.expert_butn_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: calc(100% - 40px);\n    height: 100%;\n    cursor: pointer;\n}\n\n.img {\n    width: 24px;\n    height: 24px;\n    margin-right: 6px;\n}\n\n.text {\n    width: calc(100% - 30px - 12px);\n    color: #e7e7e7;\n    font-size: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.shrink_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n}\n\n.shrink_img {\n    width: 11px;\n    height: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SideMyStoneMall_container__XQdiU`,
	"main": `SideMyStoneMall_main__UAlds`,
	"title_item": `SideMyStoneMall_title_item__uukof`,
	"collapsibleContent": `SideMyStoneMall_collapsibleContent__HVybw`,
	"item_collapsed": `SideMyStoneMall_item_collapsed__ArwtD`,
	"item_expanded": `SideMyStoneMall_item_expanded__cXG2N`,
	"expert_butn_box": `SideMyStoneMall_expert_butn_box__c6kom`,
	"img": `SideMyStoneMall_img__3kBNA`,
	"text": `SideMyStoneMall_text__jK84r`,
	"shrink_box": `SideMyStoneMall_shrink_box__8lYYa`,
	"shrink_img": `SideMyStoneMall_shrink_img__T2NjJ`
};
export default ___CSS_LOADER_EXPORT___;
